import isEmpty from 'lodash/isEmpty';
export var isDefined = obj => {
  if (!obj && obj !== 0) {
    return false;
  }
  return true;
};
export var areEmpty = values => values.every(value => isEmpty(value));
export var isA = (value, name) => value && value["is".concat(name)] && value["is".concat(name)]();